// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c6cb8b3d","455":"74478bf9","977":"ce429571"}[chunkId] + ".chunk.js";
};